// LandingPage.jsx - Hero CORRIGIDO e Fiel ao Layout

import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Col, Container, Row } from "react-bootstrap";
import api from '../../services/apiIdz';
import './style.scss';

import logo from "./img/logo.png";
import ImageWithFallback from "./img/ImageWithFallback.png";
import lpBlindagem from "./img/lp-blindagem.png";
import blindagem from "./img/blindagem.png";
import seta from "./img/seta.png";
import { useNavigationIdz } from '../../context/useNavigation';



const LandingPage = () => {


  useEffect(() => {
    if (window.__adpulse_loaded__) return;

    window.__adpulse_loaded__ = true;

    window.adpulse = window.adpulse || { cmd: [] };

    const script = document.createElement('script');
    script.src = 'https://tag.adpulse.com.br/pixel.js';
    script.async = true;

    document.body.appendChild(script);
  }, []);


  const [formSuccess, setFormSuccess] = useState(false);
  const [formDataHero, setFormDataHero] = useState({
    name: '',
    phone: '',
    email: '',
    model: '',
  });

  const [formDataFinal, setFormDataFinal] = useState({
    name: '',
    phone: '',
    email: '',
    model: '',
  });

  const handleFormChange = (formType) => (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    if (name === 'phone') {
        const digits = value.replace(/\D/g, '').substring(0, 11);
        if (digits.length > 2 && digits.length <= 7) {
            processedValue = `(${digits.substring(0, 2)}) ${digits.substring(2)}`;
        } else if (digits.length > 7) {
            processedValue = `(${digits.substring(0, 2)}) ${digits.substring(2, 7)}-${digits.substring(7, 11)}`;
        } else {
            processedValue = digits;
        }
    }

    if (formType === 'hero') {
      setFormDataHero(prev => ({ ...prev, [name]: processedValue }));
    } else {
      setFormDataFinal(prev => ({ ...prev, [name]: processedValue }));
    }
  };

const postLeadAndNavigation = async (leadId, modelName) => {
  try {
    const navigationData = {
      lead: leadId,
      origem: 'Landing 1021 Blindagens',
      paginas: window.location.pathname,
      banners: '',
      servicos: 'Blindagem',
      veiculos: modelName || '',
    };

    await api.post('/api/navigation-tracker', navigationData);
    console.log('Tracking registrado com sucesso:', navigationData);

  } catch (error) {
    console.error('Erro ao enviar tracking:', error);
  }
};

 const handleFormSubmit = async (e, formName) => {
    e.preventDefault();

    const data = formName === 'hero' ? formDataHero : formDataFinal;
    if (!data.name || !data.phone || !data.email) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    const payload = {
      tipo: 2,
      nome: data.name,
      telefone: data.phone,
      email: data.email,
      observacao: data.model,
    };

    try {
      const response = await api.post('/api/leads', payload);

      if (response && response.data) {
        const leadId = response.data; // ID retornado ex: 70
        console.log('Lead enviado com sucesso:', leadId);

        await postLeadAndNavigation(leadId, data.model);

        if (window.gtag) {
          window.gtag('event', 'conversion_event_submit_lead_form_2', {
            event_callback: () => console.log('Evento de conversão enviado'),
            event_timeout: 2000,
          });
        }

        if (window.adpulse && window.adpulse.cmd) {
          window.adpulse.cmd.push(function () {
            window.adpulse.run('track', {
              event: 'signup',
              value: 0,
              quantity: 1
            });
          });
        }

        setFormSuccess(true);

        if (formName === 'hero') {
          setFormDataHero({ name: '', phone: '', email: '', model: '' });
        } else {
          setFormDataFinal({ name: '', phone: '', email: '', model: '' });
        }

        setTimeout(() => setFormSuccess(false), 4000);
      }
    } catch (error) {
      console.error('Erro ao enviar lead:', error);
      alert('Erro ao enviar o formulário. Tente novamente mais tarde.');
    }
  };



  // ... (Funções Auxiliares - renderBenefitCard, renderCtaForm - Mantidas como antes) ...
  // (Corrigido: Adicionado o 'icon-wrapper' para o círculo verde)
  const renderBenefitCard = (icon, title, description, isSmall = false) => {
   const className = isSmall ? 'benefit-card benefit-card--small' : 'benefit-card';
    return (
      <div className={className}>
        <div className="benefit-card__icon-wrapper">
          <Icon icon={icon} />
        </div>
        <div className="benefit-card__content">
          <h3 className="benefit-card__title">{title}</h3>
          <p className="benefit-card__description">{description}</p>
        </div>
      </div>
    );
  };

  
  
 const gtagSendEventWhatsApp = (url) => {
        const callback = () => {
        };

        if (window.gtag) {
            window.gtag('event', 'conversion_event_contact_1', {
                'event_callback': callback,
                'event_timeout': 2000, // Tempo limite em milissegundos para o callback ser chamado
                // Outros parâmetros de evento, se houver
            });
        }
    };
  const { idzEvent } = useNavigationIdz()
const renderCtaForm = (type) => {
  const isHero = type === 'hero';
  const formData = isHero ? formDataHero : formDataFinal;
  const handleForm = handleFormChange(type);
  const formName = type;
  const shouldRenderHeaderAndCredibility = isHero;


  return (
    <div className="cta-form-card">
      {shouldRenderHeaderAndCredibility && (
        <h2 className="cta-form-card__title-detail">
          <strong>ENTRE EM CONTATO</strong>
          <br />
          Quero blindar o meu carro
        </h2>
      )}

      {/* Bloco de sucesso dentro do formulário */}
      {formSuccess ? (
        <div className="cta-form-card__success">
          <Icon icon="ph:check-circle-bold" className="success-icon" />
          <h3>Obrigado!</h3>
          <p>Recebemos seus dados. Em breve entraremos em contato.</p>
        </div>
      ) : (
        <form
          className={`cta-form-card__form ${formSuccess ? 'hidden' : ''}`}
          onSubmit={(e) => handleFormSubmit(e, formName)}
        >
          <div className="form-group-row">
            <input
              type="text"
              name="name"
              placeholder={isHero ? "Seu nome completo" : "Nome"}
              value={formData.name}
              onChange={handleForm}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder={isHero ? "(00) 00000-0000" : "Telefone"}
              value={formData.phone}
              onChange={handleForm}
              required
              maxLength={15}
            />
          </div>
          <input
            type="email"
            name="email"
            placeholder={isHero ? "seu@email.com" : "E-mail"}
            value={formData.email}
            onChange={handleForm}
            required
          />
          <input
            type="text"
            name="model"
            placeholder={isHero ? "Ex: BMW X5 2023" : "Modelo do carro (Ex: BMW X5 2023)"}
            value={formData.model}
            onChange={handleForm}
            required
          />

          <button
            type="submit"
            className={`cta-form-card__cta ${
              isHero ? 'cta-form-card__cta--green' : 'cta-form-card__cta--solid'
            }`}
          >
            QUERO FALAR COM UM ESPECIALISTA
          </button>
        </form>
      )}
    </div>
  );
};

 const handleClickWhat = () => {
        idzEvent("whatsapp", "Whatsapp Clicado");
        gtagSendEventWhatsApp(window.location.href);
    };
  return (
    <>
      <div className='flut-atendimento' onClick={handleClickWhat}>
          <a className='WhatsAppFlutuante' target='_black' href={`https://api.whatsapp.com/send?phone=5511997484868`}>
              <Icon className="icons" icon="ic:sharp-whatsapp" />
          </a>
      </div>
    <div className="lp-container">
      <img id="nvg_rt" src="https://cdn.navdmp.com/cus?acc=76503&cus=248506&img=1" />
      
      {/* 1. HERO SECTION (CORRIGIDO) */}
      <section className="hero-lp" style={{ marginTop: "-24px" }}>

        
        <Container className="hero-lp__content-container">
          <Row> {/* A Row agora ocupa toda a largura do Container */}

            <Col lg={12} xl={12}>
                <img src={logo} alt="1021 Blindagens" className="hero-lp__logo" />
                <a href="https://api.whatsapp.com/send?phone=5511972379189"><button className="hero-lp__cta-quote-top">SOLICITAR ORÇAMENTO</button></a>
            </Col>

            <Col lg={7} xl={7} className="hero-lp__info"> {/* Lado Esquerdo - Conteúdo Principal */}
              <div className="hero-lp__logo-badge-area">
                
                <p className="hero-lp__excellence-badge">
                  <Icon icon="ic:round-star" className="badge-icon" /> 15 anos de excelência em blindagem automotiva
                </p>
              </div>

              <h1 className="hero-lp__title">
                Blindagem <br />
                <span className="text-highlight-green">com Performance</span>
              </h1>

              <p className="hero-lp__subtitle">Leve, segura e feita para quem exige excelência.</p>

              <p className="hero-lp__text">
                Na 1021 Blindagens, a segurança do seu carro é tratada com a mesma precisão de quem ama dirigir. Blindagem homologada, até 80% mais leve, com 10 anos de garantia e tecnologia de ponta.
              </p>
              
              <a href="https://api.whatsapp.com/send?phone=5511972379189"><button className="hero-lp__cta-main">QUERO BLINDAR O MEU CARRO <Icon icon="ph:shield-check-bold" /></button></a>
              
              <div className="hero-lp__certifications">
                <div className="certification-item">
                  <span className="certification-item__icon"><Icon icon="ph:shield-check-bold" /></span>
                  <p>Certificação: <br /> <strong>Exército Brasileiro</strong></p>
                </div>
                <div className="certification-item">
                  <span className="certification-item__icon"><Icon icon="ion:timer" /></span>
                  <p>Duração: <br /> <strong>10 Anos</strong></p>
                </div>
                <div className="certification-item">
                  <span className="certification-item__icon"><Icon icon="mdi:shield-star" /></span>
                  <p>Proteção: <br /> <strong>Nível IIIA</strong></p>
                </div>
              </div>
            </Col>

            <Col lg={5} xl={5} className="d-flex justify-content-end align-items-center"> {/* Lado Direito - Formulário de Contato */}
                {/* O formulário precisa de um wrapper para o posicionamento preciso 
                <div className="hero-lp__form-wrapper">
                    {renderCtaForm('hero')}
                </div>
                */}
            </Col>
          </Row>
        </Container>
        <div className="hero-lp__scroll-down">
          <img src={seta} alt="Scroll Down" />
        </div>
      </section>

      {/* 2. TECHNOLOGY SECTION (Mantida) */}
      <section className="technology-section">
        <Container>
          <Row className="technology-section__wrapper align-items-center">
            
            <Col lg={6} className="technology-section__content">
              <p className="badge-light-green"><Icon icon="mdi:star-four-points-outline" /> Tecnologia & Performance</p>
              <h2 className="technology-section__title">
                Nossa blindagem <br />
                <span className="text-highlight-green">redefine</span> o prazer <br /> de dirigir
              </h2>

              <p className="technology-section__text">
                Com materiais de alta performance <strong>reduzimos o peso em até 80%</strong>, preservando o conforto, o desempenho e a estabilidade próxima a original do veículo.
              </p>

              <p className="technology-section__text">
                É a combinação perfeita entre segurança, leveza e sofisticação, o que faz da 1021 Blindagens a escolha de quem não aceita comprometer sua experiência ao volante.
              </p>

              <a href="https://api.whatsapp.com/send?phone=5511972379189"><button className="technology-section__cta">QUERO BLINDAR MEU CARRO <Icon icon="ph:shield-check-bold" /></button></a>
            </Col>
            
            <Col lg={6} className="technology-section__image-col">
              <div className="technology-section__image-card">
                <img src={ImageWithFallback} alt="Porta do carro com detalhe em chuva" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 3. SPECS SECTION (Mantida) */}
      <section className="specs-section">
        <Container>
          <div className="specs-section__header">
            <p className="badge-light-white"><Icon icon="ph:shield-check-bold" /> Especificações Técnicas</p>
            <h2 className="specs-section__title">
              Performance e tecnologia que <br />
              <span className="text-highlight-green">fazem a diferença</span>
            </h2>
            <p className="specs-section__text">
              Cada detalhe foi pensado para oferecer proteção máxima sem <br />comprometer a experiência de dirigir
            </p>
          </div>
          
          <Row className="specs-section__cards-grid">
            <Col md={6} lg={6} className="mb-4 mb-lg-0">
                {renderBenefitCard("ph:feather-light", "Ultra Leveza", "Material 80% mais leve que o aço inoxidável.")}
            </Col>
            <Col md={6} lg={6} className="mb-4 mb-lg-0">
                {renderBenefitCard("ion:speedometer-outline", "Performance Original", "Deixa o centro de gravidade mais próximo de um carro original.")}
            </Col>
            <Col md={6} lg={6} className="mb-4 mb-lg-0">
                {renderBenefitCard("solar:check-circle-bold", "Blindagem Nível IIIA", "Blindagem homologada pelo Exército Brasileiro – Nível IIIA.")}
            </Col>
            <Col md={6} lg={6} className="mb-4 mb-lg-0">
                {renderBenefitCard("ph:speaker-high-bold", "Acústica Premium", "Ausência de ruídos e melhor acústica da categoria.")}
            </Col>
          </Row>

          <div className="specs-section__cta-final">
            <Container className="specs-section__cta-box">
              <p className="specs-section__cta-text">Pronto para conhecer nossa solução?</p>
              <p className="specs-section__cta-subtext">Fale com nossos especialistas e descubra a melhor configuração de <br /> blindagem para o seu veículo.</p>
              <a href="https://api.whatsapp.com/send?phone=5511972379189"><button className="specs-section__cta-button">SOLICITE SEU ORÇAMENTO PERSONALIZADO <Icon icon="ph:shield-check-bold" /></button></a>
            </Container>
          </div>
        </Container>
      </section>

      <section className="after-sales-section">
        <Container>
          <Row className="after-sales-section__wrapper">
            
            <Col lg={6} className="after-sales-section__image-col mb-4 mb-lg-0">
              <div className="after-sales-section__image-card ">
                <img src={blindagem} alt="Homem dirigindo carro blindado" />
              </div>
            </Col>
            
            <Col lg={6} className="after-sales-section__content text-blindado">
              <p className="badge-light-green"><Icon icon="lucide:handshake" /> Compromisso com você</p>
              <h2 className="after-sales-section__title">
                Blindagem é só <span className="text-highlight-green">o começo</span>
              </h2>
              <p className="after-sales-section__subtitle">Excelência e cuidado vão além da entrega</p>
              
              <p className="after-sales-section__text">
                Com mais de <strong>15 anos de experiência</strong> oferecemos um pós-venda a domicílio nos primeiros meses e um suporte técnico especializado, sempre que você precisar. Na 1021 Blindagens, a relação com o cliente é tão sólida quanto o material da nossa blindagem.
              </p>

            <Row className="after-sales-section__cards-grid">
              <Col sm={6} className="mb-3">
                {renderBenefitCard("lucide:clock", "Garantia Estendida", "10 anos de cobertura completa", true)}
              </Col>
              <Col sm={6} className="mb-3">
                {renderBenefitCard("lucide:wrench", "Suporte Técnico", "Equipe especializada sempre disponível", true)}
              </Col>
              <Col sm={6} className="mb-3">
                {renderBenefitCard("lucide:trophy", "15 Anos de Mercado", "Experiência e excelência comprovada", true)}
              </Col>
              <Col sm={6} className="mb-3">
                {renderBenefitCard("lucide:heart", "Pós-venda Premium", "Atendimento a domicílio nos primeiros meses", true)}
              </Col>
            </Row>
            </Col>
          </Row>
        </Container>
      </section>


      {/* SEÇÃO: Segurança e inovação no processo de blindagem */}
      <section className="processo-section">
        <Container>
          <Row className="processo-section__header align-items-start">
            <Col lg={5}>
              <h2 className="processo-section__title">
                Segurança e inovação no <br />
                processo de blindagem
              </h2>
            </Col>
            <Col lg={7}>
              <p className="processo-section__text">
                Cada etapa foi cuidadosamente desenvolvida para garantir uma blindagem eficiente,
                mantendo o conforto e a integridade do carro. Desde o estudo dos pontos vulneráveis
                até a escolha dos melhores materiais, nossa equipe de especialistas acompanha de perto
                cada detalhe para proporcionar a melhor experiência aos nossos clientes.
              </p>
            </Col>
          </Row>

          <div className="processo-section__image-wrapper">
            <img src={lpBlindagem} alt="Processo de blindagem 1021" />
          </div>
        </Container>
      </section>

      <section className="semi-novo">
        <div className="semi-novo__container">
          
          {/* LEFT */}
          <div className="semi-novo__content">
            <span className="badge"><Icon icon="ph:shield-check" /> Blindagem para Seminovos</span>

            <h1>
              Seu seminovo merece{" "}
              <span>proteção de ponta</span>
            </h1>

            <p className="subtitle">
              Transforme seu veículo usado em uma fortaleza móvel.
            </p>

            <p className="description">
              Não importa o ano do seu veículo. Com <strong>mais de 18 anos de experiência</strong>,
              transformamos <strong>carros seminovos</strong> em veículos blindados de alta performance,
              mantendo a originalidade e valorizando seu investimento.
            </p>

            <a href="https://api.whatsapp.com/send?phone=5511972379189"><button className="cta">
              QUERO BLINDAR MEU CARRO
              <span className="shield"><Icon icon="ph:shield-check" /></span>
            </button></a>
          </div>

          {/* RIGHT */}
        <div className="semi-novo__cards">
          <div className="card">
            <div className="icon"><Icon icon="ph:chart-line-up" /></div>
            <div>
              <h3>Avaliação Técnica Completa</h3>
              <p>
                Realizamos inspeção completa do veículo para garantir que a
                estrutura está apta para receber a blindagem, verificando
                condições mecânicas e de carroceria.
              </p>
            </div>
          </div>

          <div className="card">
            <div className="icon"><Icon icon="ph:wrench" /></div>
            <div>
              <h3>Valorização do Patrimônio</h3>
              <p>
                A blindagem valoriza seu seminovo, transformando-o em um veículo
                premium com proteção balística certificada e maior valor de
                revenda.
              </p>
            </div>
          </div>

          <div className="card">
            <div className="icon"><Icon icon="ph:car" /></div>
            <div>
              <h3>Mesma Qualidade dos 0km</h3>
              <p>
                Utilizamos os mesmos materiais de alta performance e seguimos os
                mesmos padrões técnicos aplicados em veículos novos, sem
                diferenciação na qualidade.
              </p>
            </div>
          </div>
        </div>

        </div>
      </section>

      <section className="final-cta-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12} xl={12}>
              <div className="final-cta-section__wrapper"> {/* ESTE TEM O FUNDO PRETO */}
                <Row className="align-items-center">
                  
                  {/* Lado Esquerdo (Conteúdo e Credibilidade) - CORRIGIDO/COMPLETO */}
                  <Col md={6} className="final-cta-section__text-content">
                    
                    <p className="badge-light-green badge-light-green--dark"><Icon icon="ph:shield-check-bold" /> Fale com nossos especialistas</p>
                    
                    <h2 className="final-cta-section__title">
                      Pronto para elevar <br/>o <span className="text-highlight-green">nível da segurança</span> <br/>do seu carro?
                    </h2>
                    
                    <p className="final-cta-section__text">
                      Preencha seus dados abaixo e nossa equipe entrará em contato para apresentar a melhor condição de blindagem 1021 para o seu veículo.
                    </p>
                    
                    {/* Credibilidade (Ícones Check) - Usando o novo bloco de SCSS __info-final-display */}
                    <div className="final-cta-section__info-final-display">
                      <p><Icon icon="lucide:circle-check" /> Resposta em até 24h</p>
                      <p><Icon icon="lucide:circle-check" /> Sem compromisso</p>
                      <p><Icon icon="lucide:circle-check" /> Dados protegidos</p>
                    </div>

                  </Col>
                  
                  {/* Lado Direito (Formulário) 
                  <Col md={6} className="final-cta-section__form-col">
                    {renderCtaForm('final')} 
                  </Col>
                  */}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <footer className="footer">
        <Container className="footer__container">
          <Row className="align-items-start">
            <Col lg={7} className="footer__logo-area mb-4 mb-lg-0">
              <img src={logo} alt="1021 Blindagens" className="footer__logo" />
              <p className="footer__text">
                Referência em blindagem automotiva de alto padrão. Tecnologia de ponta, materiais premium e 5 anos de experiência protegendo o que você tem de mais valioso.
              </p>
            </Col>
            
            <Col lg={5} className="footer__contact-area d-flex align-items-start">
              <div className="footer__contact-separator"></div>
              <div>
                <h3 className="footer__contact-title">Entre em Contato</h3>
                <div className="footer__contact-info">
                  <p className="footer__contact-item">
                    <span className="footer__icon"><Icon icon="ph:phone-call-fill" /></span> (11) 5583-1021
                  </p>
                  <p className="footer__contact-item">
                    <span className="footer__icon"><Icon icon="basil:location-solid" /></span> Alameda dos Guaiatás, n° 729 - Saúde - São Paulo - SP
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        
        <div className="footer__copyright">
            <Container>
                Todos os direitos reservados ® 1021 Motors | 2025
            </Container>
        </div>
      </footer>
    </div></>
  );
};

export default LandingPage;